import { UserProfile, Wallet } from '@dynamic-labs/sdk-react-core';
import { useMemo } from 'react';

import { Metadata } from '@repo/types-client';

/**
 * Custom hook to check if the user has a default wallet address.
 * @function useHasDefaultAddress
 * @param {Wallet[]} userWallets - The list of user wallets.
 * @param {UserProfile | undefined} user - The user profile.
 * @returns {boolean} True if the user has a default wallet address, false otherwise.
 */
export const useHasDefaultAddress = (
  userWallets: Wallet[],
  user: UserProfile | undefined,
) => {
  return useMemo(
    () =>
      userWallets.some(
        (wallet: Wallet) =>
          wallet.address === (user?.metadata as Metadata)?.defaultAddress,
      ),
    [userWallets, user?.metadata],
  );
};
